import { TweenMax } from 'gsap';
import { SplitText } from '@/scripts/libs/SplitText';

const WineDetailsInitial = (element) => {
  const title = element.querySelector('.wine-details__title');
  const text = element.querySelector('.wine-details__text');
  const image = element.querySelector('.wine-details__image');
  const details = [...element.querySelectorAll('.wine-details__detail')];

  const split = new SplitText(title, { charsClass: 'wine-details__title-char' });
  TweenMax.set(text, { y: 100, autoAlpha: 0 });
  TweenMax.set(image, { autoAlpha: 0 });
  TweenMax.set(details, { y: 100, autoAlpha: 0 });
  TweenMax.set(split.chars, { y: 80, autoAlpha: 0 });
};

export default WineDetailsInitial;
